module.exports = __webpack_public_path__ + "img/globe_icon.00add110.svg";